import type { CommunityGroupCreateResponse } from '@space-events/toggleCommunityGroupModal'

import CollapseHeaderActions from './collapseHeaderActions'
import { CollapseTitle } from './collapseTitle'

export type CollapseHeaderProps = {
  group: CommunityGroupCreateResponse
  hasActions: boolean
  handleAddCommunity: () => void
}

const CollapseHeader = ({ group, hasActions, handleAddCommunity }: CollapseHeaderProps) => {
  if (hasActions) {
    return (
      <CollapseHeaderActions
        version='new'
        group={group}
        toggleAddCommunityModal={handleAddCommunity}
      />
    )
  }

  return <CollapseTitle version='new'>{group.name}</CollapseTitle>
}

export default CollapseHeader
